/**
 * Resolves where an authenticated user must be sent, returning a single canonical
 * destination (or null to stay put). Computing one target — instead of several
 * independent redirect rules — plus the `target !== pathname` check is what prevents
 * the CG-456 infinite redirect loop (org-join gate takes precedence over verification).
 */
type MeRedirectInput =
  | {
      availableOrgs: readonly unknown[];
      organizations: readonly unknown[];
      isOnboarded: boolean;
    }
  | null
  | undefined;

export function resolveAuthRedirect(me: MeRedirectInput, inUnverifiedMode: boolean, pathname: string): string | null {
  if (!me) return null;

  const target =
    me.availableOrgs.length > 0 && me.organizations.length === 0
      ? '/join-organization'
      : me.isOnboarded === false && !inUnverifiedMode
        ? '/verification'
        : me.isOnboarded === true && pathname === '/verification'
          ? '/home'
          : null;

  // Converge: never redirect to the page we are already on.
  return target && target !== pathname ? target : null;
}
